import { BlogPost, BlogCategory, BlogTag } from '../types';

export const mockCategories: BlogCategory[] = [
  {
    id: '1',
    name: 'Vida Consciente',
    slug: 'vida-consciente',
    description: 'Bienestar, mindfulness y vida equilibrada',
    postCount: 8
  },
  {
    id: '2',
    name: 'Cultura & Comunidad',
    slug: 'cultura-comunidad',
    description: 'Eventos, tradiciones y comunidad local',
    postCount: 6
  },
  {
    id: '3',
    name: 'Diseño con Propósito',
    slug: 'diseno-proposito',
    description: 'Espacios que nutren el alma y inspiran',
    postCount: 4
  },
  {
    id: '4',
    name: 'Sabores que Nutren',
    slug: 'sabores-nutren',
    description: 'Café de especialidad y gastronomía consciente',
    postCount: 7
  },
  {
    id: '5',
    name: 'Eventos',
    slug: 'eventos',
    description: 'Talleres, charlas y experiencias transformadoras',
    postCount: 5
  },
  {
    id: '6',
    name: 'Exploración & Inspiración',
    slug: 'exploracion-inspiracion',
    description: 'Viajes, arte y descubrimientos que inspiran',
    postCount: 6
  }
];

export const mockTags: BlogTag[] = [
  { id: '1', name: 'Mindfulness', slug: 'mindfulness', postCount: 8 },
  { id: '2', name: 'Café de Especialidad', slug: 'cafe-especialidad', postCount: 12 },
  { id: '3', name: 'Bienestar', slug: 'bienestar', postCount: 10 },
  { id: '4', name: 'Sostenibilidad', slug: 'sostenibilidad', postCount: 6 },
  { id: '5', name: 'Comunidad Local', slug: 'comunidad-local', postCount: 9 },
  { id: '6', name: 'Arte & Cultura', slug: 'arte-cultura', postCount: 7 },
  { id: '7', name: 'Gastronomía', slug: 'gastronomia', postCount: 8 },
  { id: '8', name: 'Espacios Conscientes', slug: 'espacios-conscientes', postCount: 5 },
  { id: '9', name: 'Talleres', slug: 'talleres', postCount: 4 },
  { id: '10', name: 'Inspiración', slug: 'inspiracion', postCount: 11 }
];

export const mockPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Alere Café: un refugio en la ciudad para reconectar con tu esencia',
    excerpt: 'Descubre cómo cada rincón fue diseñado para nutrir cuerpo, mente y alma.',
    content: 'En un mundo acelerado, Alere Café emerge como un oasis de tranquilidad y conexión auténtica...',
    articleContent: {
      introduction: 'En medio del ruido y la prisa de la ciudad, nace Alere Café como una pausa intencionada. Más que una cafetería, es un santuario moderno para quienes buscan reconectar con lo esencial: el sabor, la presencia, la calma. Inspirado en la palabra latina alere, que significa nutrir, cuidar y sostener, este espacio fue creado para recordarnos que el bienestar comienza en los pequeños rituales del día a día. Una taza de café, una conversación sin prisa, una luz suave al atardecer… todo cuenta.',
      sections: [
        {
          id: 'section1',
          title: '🌿 El origen: un espacio que honra la pausa',
          content: 'Desde el diseño interior hasta la música de fondo, cada detalle de Alere fue pensado para invitarte a regresar a ti. Los colores tierra, la madera natural, las plantas vivas y los aromas de nuestra barra de café se entrelazan para crear un ambiente que acoge y reconforta.\n\nNo es casualidad: creemos que los espacios también curan, que la belleza sencilla tiene poder y que la pausa es revolucionaria.',
          type: 'text'
        },
        {
          id: 'section2',
          title: '☕ Café como ritual',
          content: 'Cada bebida en Alere es preparada con intención. Nuestro café de especialidad proviene de productores comprometidos con la tierra y con procesos éticos. Pero más allá del origen, lo que nos importa es el cómo se sirve: con respeto, presencia y mucho corazón.\n\nAquí no se trata de rapidez, sino de ritualizar lo cotidiano. Ya sea un espresso al sol o una infusión herbal para cerrar el día, tu momento con la taza es tuyo.',
          type: 'text'
        },
        {
          id: 'section3',
          title: '🍽️ Alimentos que acompañan',
          content: 'El menú de Alere es ligero pero significativo. Tapas frescas, dulces sanos, desayunos sin prisas. Todos los ingredientes se eligen con conciencia: lo local, lo sencillo, lo que nutre sin agobiar.',
          type: 'text'
        },
        {
          id: 'section4',
          content: 'Nuestra intención es que cada platillo te haga sentir bien, sin pretensiones, sin exceso. Solo alimentos que hablen tu mismo lenguaje: el de la conexión y el cuidado.',
          image: {
            url: '/article-image-1-62b918.png',
            alt: 'Interior acogedor de Alere Café con decoración natural',
            width: 854,
            height: 569
          },
          type: 'text-with-image'
        },
        {
          id: 'section5',
          title: '🧘‍♀️ Más allá del café: un lugar para volver a ti',
          content: 'Alere también es un punto de encuentro para el alma. A veces será a través de una charla íntima, otras veces a través de un evento creativo, una lectura silenciosa, una tarde sola contigo.\n\nQueremos que este lugar te invite a sentirte bienvenida, sin exigencias ni etiquetas. Que vengas como eres y te vayas un poco más ligera.',
          type: 'text'
        },
        {
          id: 'section6',
          content: '',
          image: {
            url: '/article-image-2.png',
            alt: 'Espacio de Alere Café con plantas y luz natural',
            width: 1280,
            height: 854,
            caption: 'No vocent postulant neglegentur mei, ea sea tantas viderer'
          },
          type: 'image'
        },
        {
          id: 'section7',
          content: 'En cada rincón de Alere hay una intención: recordarte que puedes detenerte, respirar y volver a ti.\n\nBienvenid@ a este espacio que también es tuyo.',
          type: 'text'
        }
      ],
      conclusion: ''
    },
    author: {
      id: '1',
      name: 'María González',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b06d3d22?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-20T09:00:00Z',
    category: mockCategories[0], // Vida Consciente
    tags: [mockTags[7], mockTags[0], mockTags[9]], // Espacios Conscientes, Mindfulness, Inspiración
    featuredImage: {
      url: '/article-hero-image.png',
      alt: 'Interior acogedor de Alere Café con plantas y luz natural',
      width: 893,
      height: 1280
    },
    slug: 'alere-cafe-refugio-ciudad-reconectar-esencia',
    readTimeMinutes: 6,
    isPublished: true,
    isFeatured: true
  },
  {
    id: '2',
    title: 'La magia de la Colonia Americana: un recorrido visual por nuestro barrio',
    excerpt: 'Explora con nosotros los rincones más hermosos de nuestro barrio histórico.',
    content: 'La Colonia Americana guarda secretos y belleza en cada esquina...',
    author: {
      id: '2',
      name: 'Carlos Mendoza',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-18T11:30:00Z',
    category: mockCategories[1], // Cultura & Comunidad
    tags: [mockTags[4], mockTags[5]], // Comunidad Local, Arte & Cultura
    featuredImage: {
      url: '/blog-image-2-figma.png',
      alt: 'Vista de la Colonia Americana con arquitectura histórica',
      width: 630,
      height: 840
    },
    slug: 'magia-colonia-americana-recorrido-visual-barrio',
    readTimeMinutes: 8,
    isPublished: true,
    isFeatured: false
  },
  {
    id: '3',
    title: 'El lenguaje visual de Alere: colores, símbolos y emociones',
    excerpt: 'Descubre la historia detrás de cada elemento visual que define nuestra identidad.',
    content: 'Cada color, cada forma, cada detalle de Alere cuenta una historia...',
    author: {
      id: '3',
      name: 'Ana Sofía López',
      avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-16T08:15:00Z',
    category: mockCategories[2], // Diseño con Propósito
    tags: [mockTags[9], mockTags[5]], // Inspiración, Arte & Cultura
    featuredImage: {
      url: '/blog-image-3-figma-1849ab.png',
      alt: 'Elementos visuales y paleta de colores de Alere Café',
      width: 854,
      height: 561
    },
    slug: 'lenguaje-visual-alere-colores-simbolos-emociones',
    readTimeMinutes: 5,
    isPublished: true,
    isFeatured: false
  },
  {
    id: '4',
    title: '¿Qué hay en nuestro menú? Alimentos para el alma, servidos sin prisa',
    excerpt: 'Un viaje gastronómico pensado para nutrir todos tus sentidos.',
    content: 'Nuestro menú va más allá de la comida: es una experiencia sensorial completa...',
    author: {
      id: '4',
      name: 'Roberto Silva',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-14T13:45:00Z',
    category: mockCategories[3], // Sabores que Nutren
    tags: [mockTags[6], mockTags[1]], // Gastronomía, Café de Especialidad
    featuredImage: {
      url: '/blog-image-4-figma.png',
      alt: 'Platos artesanales de Alere Café servidos con cuidado',
      width: 1280,
      height: 854
    },
    slug: 'que-hay-menu-alimentos-alma-servidos-sin-prisa',
    readTimeMinutes: 7,
    isPublished: true,
    isFeatured: false
  },
  {
    id: '5',
    title: 'Aprende a pintar con números: tu propia Tote Bag',
    excerpt: 'Taller creativo donde la pintura y el diseño se encuentran.',
    content: 'Descubre el arte de la pintura con números mientras creas tu propia tote bag personalizada...',
    author: {
      id: '5',
      name: 'Laura Martínez',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-12T16:00:00Z',
    category: mockCategories[4], // Eventos
    tags: [mockTags[8], mockTags[5]], // Talleres, Arte & Cultura
    featuredImage: {
      url: '/blog-image-5-figma-56a241.png',
      alt: 'Taller de pintura con números y tote bags personalizadas',
      width: 900,
      height: 591
    },
    slug: 'aprende-pintar-numeros-propia-tote-bag',
    readTimeMinutes: 4,
    isPublished: true,
    isFeatured: false
  },
  {
    id: '6',
    title: 'Lugares que inspiran: arquitectura, naturaleza y espíritu creativo',
    excerpt: 'Un recorrido por espacios que despiertan la creatividad y nutren el alma.',
    content: 'Exploramos lugares únicos donde la arquitectura y la naturaleza se unen para inspirar...',
    author: {
      id: '6',
      name: 'Diego Ramírez',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-10T10:20:00Z',
    category: mockCategories[5], // Exploración & Inspiración
    tags: [mockTags[9], mockTags[7]], // Inspiración, Espacios Conscientes
    featuredImage: {
      url: '/blog-image-6-figma.png',
      alt: 'Espacios arquitectónicos que inspiran creatividad',
      width: 800,
      height: 600
    },
    slug: 'lugares-inspiran-arquitectura-naturaleza-espiritu-creativo',
    readTimeMinutes: 6,
    isPublished: true,
    isFeatured: false
  },
  {
    id: '7',
    title: 'Postales desde la pausa: momentos capturados en Alere',
    excerpt: 'Una colección de instantes que definen la esencia de nuestro espacio.',
    content: 'Cada momento en Alere cuenta una historia, cada rincón guarda memorias...',
    author: {
      id: '7',
      name: 'Sofía Herrera',
      avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
    },
    publishedDate: '2024-01-08T14:30:00Z',
    category: mockCategories[1], // Cultura & Comunidad
    tags: [mockTags[9], mockTags[4]], // Inspiración, Comunidad Local
    featuredImage: {
      url: '/blog-image-7-figma.png',
      alt: 'Momentos cotidianos capturados en Alere Café',
      width: 720,
      height: 540
    },
    slug: 'postales-desde-pausa-momentos-capturados-alere',
    readTimeMinutes: 5,
    isPublished: true,
    isFeatured: false
  }
];
